import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RetailScanningService } from '../../services/retail-scanning.service';
import { CardModule } from 'primeng/card';
import { LoadingComponent } from '../../../shared/components/loading/loading.component';

@Component({
  selector: 'app-view-scan-retail-qr-result',
  imports: [
    CardModule,
    LoadingComponent
  ],
  templateUrl: './view-scan-retail-qr-result.component.html',
  styleUrl: './view-scan-retail-qr-result.component.scss'
})
export class ViewScanRetailQrResultComponent {


  retailQrId: any = null;
  customerId: any = null;

  message: string = "";
  hasError: boolean = false;
  
  isLoading: boolean = false;


  constructor(
    private activatedRoute: ActivatedRoute,
    private retailScanningService: RetailScanningService
  ) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: any) => {
      if (params['retailQrId'] && params['customerId']) {
        this.retailQrId = params['retailQrId'];
        this.customerId = params['customerId'];
        this.getScanResult();
      }
    })
  }

  getScanResult() {
    this.isLoading = true;
    let body = {
      "retail_qr_id": this.retailQrId,
      "customer_id": this.customerId
    }
    
    this.retailScanningService.getScanResult(body).subscribe({
      next: (resp: any) => {
        this.message = resp?.message;
        this.hasError = false;
        this.isLoading = false;
      }, error: (error: any) => {
        this.hasError = true;
        this.isLoading = false;
        this.message = error.error?.message;

      }
    })
  }

}
